const DAY = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  timeZone: "UTC",
});
const YEAR = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  timeZone: "UTC",
});
const SECONDS = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
  timeZone: "UTC",
});
const MINUTES = new Intl.DateTimeFormat("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZone: "UTC",
});

/**
 * A time range on one line, in UTC. Within one UTC day, the date once and
 * the times to the second: `"Sep 30, 2026 15:37:29 → 15:47:37 UTC"`. Across
 * days, each day with its time to the minute and no year:
 * `"Sep 30, 17:37 → Oct 1, 02:10 UTC"`.
 */
export function formatUtcRange(start: Date, end: Date): string {
  const startDay = DAY.format(start);
  const sameDay =
    startDay === DAY.format(end) && YEAR.format(start) === YEAR.format(end);
  if (sameDay) {
    return `${startDay}, ${YEAR.format(start)} ${SECONDS.format(start)} → ${SECONDS.format(end)} UTC`;
  }
  return `${startDay}, ${MINUTES.format(start)} → ${DAY.format(end)}, ${MINUTES.format(end)} UTC`;
}
